import { render, staticRenderFns } from "./knowledgeList.vue?vue&type=template&id=f7774c72&scoped=true"
import script from "./knowledgeList.vue?vue&type=script&lang=js"
export * from "./knowledgeList.vue?vue&type=script&lang=js"
import style0 from "./knowledgeList.vue?vue&type=style&index=0&id=f7774c72&prod&lang=scss&scoped=true"
import style1 from "./knowledgeList.vue?vue&type=style&index=1&id=f7774c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7774c72",
  null
  
)

export default component.exports